import { gql, useMutation } from '@apollo/client'
import { useAuthorizationContext } from '@emico-hooks/login-token'
import { useCallback, useState } from 'react'

import { query as getCustomerVouchersQuery } from './customerVouchers.query'
import {
    CustomerCouponRemoveResult,
    MutationCustomerCouponRemoveArgs,
} from '../graphql/schema.generated'
import { M2ApiResponseError } from '../utils/RestApi'
import withSentry from '../utils/withSentry'

const REMOVE_LOYALTY_VOUCHER = gql`
    mutation RemoveCustomerCoupon($code: String!) {
        customerCouponRemove(code: $code) {
            result
        }
    }
`

export const useRemoveVoucher = () => {
    const authorizationContext = useAuthorizationContext()
    const [isLoading, setLoading] = useState<boolean>(false)

    // eslint-disable-next-line no-restricted-syntax
    const [removeLoyaltyVoucher] = useMutation<
        CustomerCouponRemoveResult,
        Pick<MutationCustomerCouponRemoveArgs, 'code'>
    >(REMOVE_LOYALTY_VOUCHER, {
        refetchQueries: () => [
            {
                query: getCustomerVouchersQuery,
                context: authorizationContext,
            },
        ],
        context: authorizationContext,
        awaitRefetchQueries: true,
    })

    const removeVoucher = useCallback(
        async (voucherCode: string) => {
            setLoading(true)
            try {
                await removeLoyaltyVoucher({
                    variables: {
                        code: voucherCode,
                    },
                })

                // Refresh cart to update totals
                //await dispatch(getCartDetails({ forceRefresh: true }))

                setLoading(false)
            } catch (err) {
                setLoading(false)

                if (!(err instanceof Error)) {
                    return
                }
                let errorMessage = err.message
                if (err instanceof M2ApiResponseError) {
                    errorMessage = err.userMessage
                }

                console.error(errorMessage)

                withSentry((Sentry) => {
                    Sentry.captureException(err)
                })

                return
            }
        },
        [removeLoyaltyVoucher],
    )

    return { isLoading, removeVoucher }
}
